/**
 * Shop All Glasses — curated PLP order.
 * Brand hierarchy top → first 60 (3 designers, 2 curated house, repeat) → other designers → house last.
 * Disabled when customer picks price or name sort.
 */
(function () {
  const CONFIG_ID = 'ciw-eyeglasses-shop-all-sort-config';
  const GRID_SEL = '#product-grid';
  const CARD_SEL = '.ciw-card';
  const MIX_TARGET = 60;

  const BRAND_PRIORITY = [
    'ray-ban',
    'versace',
    'gucci',
    'ralph-lauren',
    'polo-ralph-lauren',
    'dita',
    'tom-ford',
    'prada',
    'face-a-face',
    'burberry',
    'hugo-boss',
    'cazal',
    'balenciaga',
    'emporio-armani',
    'garrett-leight',
    'michael-kors',
    'morel',
    'salvatore-ferragamo',
    'simply-lite',
    'vince-camuto',
    'saint-laurent',
    'other-designer',
  ];

  const DESIGNER_PRIORITY = BRAND_PRIORITY.filter(function (key) {
    return key !== 'other-designer';
  });

  const BOTTOM_HOUSE_ORDER = ['millennial', 'grande', 'trendy', '4u', 'peachtree', 'di-caprio'];

  function isNativeShopifySort() {
    const sort = new URLSearchParams(window.location.search).get('sort_by');
    return (
      sort === 'price-ascending' ||
      sort === 'price-descending' ||
      sort === 'title-ascending' ||
      sort === 'title-descending'
    );
  }

  function clearShopAllLoadingState() {
    const wrap = document.querySelector('.ciw-product-grid-wrap--shop-all-sort');
    if (wrap) wrap.classList.remove('is-loading');
    window.ciwShopAllSortPrefetchComplete = true;
  }

  function isPriceOrNameSort() {
    return isNativeShopifySort();
  }

  function isShopAllSortGrid() {
    const grid = document.querySelector(GRID_SEL);
    return Boolean(grid && grid.dataset.ciwEyeglassesShopAllSort === 'true');
  }

  function readConfig() {
    const el = document.getElementById(CONFIG_ID);
    if (!el) return { mixHandles: [], mixHandleSet: new Set() };
    try {
      const parsed = JSON.parse(el.textContent);
      const mixHandles = Array.isArray(parsed.mixHandles)
        ? parsed.mixHandles.map(function (handle) {
            return String(handle).trim();
          }).filter(Boolean)
        : [];
      return {
        mixHandles: mixHandles,
        mixHandleSet: new Set(mixHandles),
      };
    } catch (error) {
      return { mixHandles: [], mixHandleSet: new Set() };
    }
  }

  function normalizeVendor(vendor) {
    return String(vendor || '')
      .toLowerCase()
      .replace(/\s+/g, '-');
  }

  function brandBucket(vendor) {
    const v = normalizeVendor(vendor);
    if (!v) return 'other-designer';

    if (v.includes('4u') || v === '4-u') return '4u';
    if (v.includes('peachtree')) return 'peachtree';
    if (v.includes('millennial')) return 'millennial';
    if (v.includes('di-caprio') || v.includes('dicaprio')) return 'di-caprio';
    if (v.includes('grande')) return 'grande';
    if (v.includes('trendy')) return 'trendy';

    if (v.includes('ray-ban') || v.includes('rayban')) return 'ray-ban';
    if (v.includes('versace')) return 'versace';
    if (v.includes('gucci')) return 'gucci';
    if (v.includes('polo-ralph') || (v.includes('polo') && v.includes('ralph'))) return 'polo-ralph-lauren';
    if (v.includes('ralph-lauren') || v.includes('ralphlauren')) return 'ralph-lauren';
    if (v.includes('dita')) return 'dita';
    if (v.includes('tom-ford') || v.includes('tomford')) return 'tom-ford';
    if (v.includes('prada')) return 'prada';
    if (v.includes('face-a-face') || v.includes('faceaface')) return 'face-a-face';
    if (v.includes('burberry')) return 'burberry';
    if (v.includes('hugo-boss') || v.includes('hugoboss') || v === 'hugo') return 'hugo-boss';
    if (v.includes('cazal')) return 'cazal';
    if (v.includes('balenciaga')) return 'balenciaga';
    if (v.includes('emporio-armani') || (v.includes('armani') && !v.includes('giorgio'))) return 'emporio-armani';
    if (v.includes('garrett-leight') || v.includes('garrettleight')) return 'garrett-leight';
    if (v.includes('michael-kors') || v.includes('michaelkors')) return 'michael-kors';
    if (v.includes('morel')) return 'morel';
    if (v.includes('salvatore-ferragamo') || v.includes('ferragamo')) return 'salvatore-ferragamo';
    if (v.includes('simply-lite') || v.includes('simplylite')) return 'simply-lite';
    if (v.includes('vince-camuto') || v.includes('vincecamuto')) return 'vince-camuto';
    if (v.includes('saint-laurent') || v.includes('saintlaurent') || v.includes('ysl')) return 'saint-laurent';

    return 'other-designer';
  }

  function isBottomHouseBrand(brand) {
    return BOTTOM_HOUSE_ORDER.indexOf(brand) !== -1;
  }

  function isEyeglassesCard(card) {
    if (!card) return false;
    if (card.dataset.ciwGlassesType === 'sunglasses') return false;
    const productType = String(card.dataset.ciwProductType || '').toUpperCase();
    if (productType.indexOf('SUNGLASS') !== -1) return false;
    return true;
  }

  function isMixEligible(card, mixHandles) {
    const handle = card.dataset.handle;
    if (handle && mixHandles.has(handle)) return true;
    return card.dataset.ciwBestSeller === 'true';
  }

  function createEmptyPools() {
    const pools = { 'mix-house': [] };
    BRAND_PRIORITY.forEach(function (key) {
      pools[key] = [];
    });
    BOTTOM_HOUSE_ORDER.forEach(function (key) {
      pools['bottom-' + key] = [];
    });
    return pools;
  }

  function pullFromPool(pools, poolName) {
    const pool = pools[poolName];
    if (!pool || !pool.length) return null;
    return pool.shift();
  }

  function pullDesignerRoundRobin(pools, cycleIdx) {
    const attempts = DESIGNER_PRIORITY.length + 1;
    for (let i = 0; i < attempts; i += 1) {
      const slot = (cycleIdx + i) % (DESIGNER_PRIORITY.length + 1);
      const brand = slot < DESIGNER_PRIORITY.length
        ? DESIGNER_PRIORITY[slot]
        : 'other-designer';
      const item = pullFromPool(pools, brand);
      if (item) {
        return { item: item, nextIdx: cycleIdx + i + 1 };
      }
    }
    return { item: null, nextIdx: cycleIdx + 1 };
  }

  function buildOrderedCards(cards, config) {
    const mixHandles = config.mixHandleSet || new Set();
    const mixHandleOrder = new Map();
    (config.mixHandles || []).forEach(function (handle, index) {
      mixHandleOrder.set(handle, index);
    });

    const used = new Set();
    const ordered = [];
    const pools = createEmptyPools();

    function takeItem(item) {
      if (!item || used.has(item.handle)) return false;
      used.add(item.handle);
      ordered.push(item.card);
      return true;
    }

    function takeDesigners(count, cycleIdx) {
      let nextIdx = cycleIdx;
      for (let i = 0; i < count && ordered.length < MIX_TARGET; i += 1) {
        const pulled = pullDesignerRoundRobin(pools, nextIdx);
        nextIdx = pulled.nextIdx;
        takeItem(pulled.item);
      }
      return nextIdx;
    }

    function takeMixHouse(count) {
      for (let i = 0; i < count && ordered.length < MIX_TARGET; i += 1) {
        if (!pools['mix-house'].length) break;
        takeItem(pullFromPool(pools, 'mix-house'));
      }
    }

    cards.forEach(function (card) {
      const handle = card.dataset.handle;
      if (!handle || !isEyeglassesCard(card)) return;

      const brand = brandBucket(card.dataset.vendor || card.dataset.brandSort || '');
      const item = { card: card, handle: handle, brand: brand };

      if (isBottomHouseBrand(brand)) {
        if (isMixEligible(card, mixHandles)) {
          pools['mix-house'].push(item);
        } else {
          pools['bottom-' + brand].push(item);
        }
        return;
      }

      if (card.dataset.ciwBestSeller === 'true' && isMixEligible(card, mixHandles)) {
        pools['mix-house'].push(item);
        return;
      }

      const poolName = brand === 'other-designer' || DESIGNER_PRIORITY.indexOf(brand) === -1
        ? 'other-designer'
        : brand;
      pools[poolName].push(item);
    });

    Object.keys(pools).forEach(function (poolName) {
      if (poolName.indexOf('bottom-') === 0 || poolName === 'mix-house') return;
      pools[poolName].sort(function (a, b) {
        return a.handle.localeCompare(b.handle);
      });
    });

    pools['mix-house'].sort(function (a, b) {
      const aOrder = mixHandleOrder.has(a.handle) ? mixHandleOrder.get(a.handle) : 9999;
      const bOrder = mixHandleOrder.has(b.handle) ? mixHandleOrder.get(b.handle) : 9999;
      if (aOrder !== bOrder) return aOrder - bOrder;
      const aMix = mixHandles.has(a.handle) ? 0 : 1;
      const bMix = mixHandles.has(b.handle) ? 0 : 1;
      if (aMix !== bMix) return aMix - bMix;
      return a.handle.localeCompare(b.handle);
    });

    BOTTOM_HOUSE_ORDER.forEach(function (brand) {
      const pool = pools['bottom-' + brand];
      if (pool) {
        pool.sort(function (a, b) {
          return a.handle.localeCompare(b.handle);
        });
      }
    });

    let designerCycleIdx = 0;
    let stalemate = 0;
    while (ordered.length < MIX_TARGET && stalemate < DESIGNER_PRIORITY.length * 48) {
      const before = ordered.length;
      const hasMixHouse = pools['mix-house'].length > 0;

      designerCycleIdx = takeDesigners(3, designerCycleIdx);

      if (hasMixHouse) {
        takeMixHouse(2);
      } else {
        designerCycleIdx = takeDesigners(3, designerCycleIdx);
      }

      stalemate = ordered.length === before ? stalemate + 1 : 0;
    }

    BRAND_PRIORITY.forEach(function (brand) {
      let item;
      while ((item = pullFromPool(pools, brand))) {
        takeItem(item);
      }
    });

    pools['mix-house'].forEach(function (item) {
      if (isBottomHouseBrand(item.brand)) {
        pools['bottom-' + item.brand].push(item);
      } else if (!pools['bottom-best-seller']) {
        pools['bottom-best-seller'] = [item];
      } else {
        pools['bottom-best-seller'].push(item);
      }
    });
    pools['mix-house'] = [];

    BOTTOM_HOUSE_ORDER.forEach(function (brand) {
      const pool = pools['bottom-' + brand] || [];
      pool.forEach(function (item) {
        takeItem(item);
      });
    });

    if (pools['bottom-best-seller']) {
      pools['bottom-best-seller'].sort(function (a, b) {
        return a.handle.localeCompare(b.handle);
      });
      pools['bottom-best-seller'].forEach(function (item) {
        takeItem(item);
      });
    }

    cards.forEach(function (card) {
      const handle = card.dataset.handle;
      if (handle && !used.has(handle)) {
        used.add(handle);
        ordered.push(card);
      }
    });

    return ordered;
  }

  function hasActiveShopAllFacetFilter() {
    const params = new URLSearchParams(window.location.search);
    if (params.get('ciw_shape_group')) return true;
    if (params.get('ciw_gusa_union')) return true;
    let active = false;
    params.forEach(function (value, key) {
      if (active) return;
      const normalizedKey = key.toLowerCase();
      if (
        (normalizedKey.indexOf('vendor') !== -1 ||
          normalizedKey.indexOf('gender') !== -1 ||
          normalizedKey.indexOf('shape') !== -1 ||
          normalizedKey.indexOf('frame_type') !== -1) &&
        String(value || '').trim()
      ) {
        active = true;
      }
    });
    return active;
  }

  function sortGrid() {
    const grid = document.querySelector(GRID_SEL);
    const wrap = grid && grid.closest('.ciw-product-grid-wrap');
    if (!isShopAllSortGrid()) return;

    if (hasActiveShopAllFacetFilter()) {
      if (wrap) wrap.classList.remove('is-loading');
      return;
    }

    if (window.ciwViewMoreLoading) return;

    if (isPriceOrNameSort()) {
      if (wrap) wrap.classList.remove('is-loading');
      return;
    }

    if (!grid) return;

    if (
      wrap &&
      wrap.classList.contains('is-loading') &&
      !window.ciwShopAllSortPrefetchComplete
    ) {
      return;
    }

    const config = readConfig();
    const cards = Array.prototype.slice.call(grid.querySelectorAll(CARD_SEL));
    if (!cards.length) {
      if (wrap) wrap.classList.remove('is-loading');
      return;
    }

    const ordered = buildOrderedCards(cards, config);

    ordered.forEach(function (card) {
      card.dataset.ciwSettled = 'true';
      grid.appendChild(card);
    });

    window.ciwShopAllSettledCount = ordered.length;

    if (wrap) wrap.classList.remove('is-loading');
    document.dispatchEvent(new CustomEvent('ciw:shop-all-sort-complete'));
    if (typeof window.ciwUpdateViewMoreCount === 'function') {
      window.ciwUpdateViewMoreCount(grid);
    }
  }

  function sortAppendOnly(anchorCount) {
    const grid = document.querySelector(GRID_SEL);
    if (!grid || !isShopAllSortGrid() || isPriceOrNameSort()) return;

    const allCards = Array.prototype.slice.call(grid.querySelectorAll(CARD_SEL));
    let settled = allCards.filter(function (card) {
      return card.dataset.ciwSettled === 'true';
    });
    let incoming = allCards.filter(function (card) {
      return card.dataset.ciwSettled !== 'true';
    });

    if (!settled.length && anchorCount != null) {
      const settledCount = Math.min(anchorCount, allCards.length);
      settled = allCards.slice(0, settledCount);
      incoming = allCards.slice(settledCount);
    }

    if (!incoming.length) {
      allCards.forEach(function (card) {
        card.dataset.ciwSettled = 'true';
      });
      window.ciwShopAllSettledCount = allCards.length;
      return;
    }

    const incomingByHandle = new Map();
    incoming.forEach(function (card) {
      const handle = card.dataset.handle;
      if (handle) incomingByHandle.set(handle, card);
    });

    const orderedNew = buildOrderedCards(incoming, readConfig());
    const orderedSet = new Set(orderedNew);
    incoming.forEach(function (card) {
      if (!orderedSet.has(card)) {
        orderedNew.push(card);
      }
    });

    let insertAfter = settled.length ? settled[settled.length - 1] : null;

    orderedNew.forEach(function (card) {
      if (insertAfter) {
        insertAfter.insertAdjacentElement('afterend', card);
        insertAfter = card;
      } else {
        grid.appendChild(card);
        insertAfter = card;
      }
    });

    incomingByHandle.forEach(function (card) {
      if (!card.isConnected || !grid.contains(card)) {
        if (insertAfter) {
          insertAfter.insertAdjacentElement('afterend', card);
          insertAfter = card;
        } else {
          grid.appendChild(card);
          insertAfter = card;
        }
      }
    });

    grid.querySelectorAll(CARD_SEL).forEach(function (card) {
      card.dataset.ciwSettled = 'true';
    });

    window.ciwShopAllSettledCount = grid.querySelectorAll(CARD_SEL).length;
    document.dispatchEvent(new CustomEvent('ciw:shop-all-sort-complete'));
    if (typeof window.ciwUpdateViewMoreCount === 'function') {
      window.ciwUpdateViewMoreCount(grid);
    }
  }

  window.ciwEyeglassesShopAllSortAppend = function (anchorCount) {
    sortAppendOnly(anchorCount);
  };

  window.ciwEyeglassesShopAllSortRun = function () {
    if (!isShopAllSortGrid()) return;
    if (isNativeShopifySort()) {
      clearShopAllLoadingState();
      return;
    }
    sortGrid();
  };

  document.addEventListener('ciw:collection-updated', function (event) {
    if (!isShopAllSortGrid() || isPriceOrNameSort()) return;
    if (window.ciwViewMoreLoading) return;
    if (event && event.detail && event.detail.appendOnly) return;
    const wrap = document.querySelector('.ciw-product-grid-wrap--shop-all-sort');
    if (
      wrap &&
      wrap.classList.contains('is-loading') &&
      !window.ciwShopAllSortPrefetchComplete
    ) {
      return;
    }
    sortGrid();
  });
})();
